import { WALKTHROUGHS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/walkthroughs_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'siteSurveyAssociatedWalkthroughs',
	'walkthroughsIndex',
	'locationAssociatedWalkthroughs',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
